var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-register-card"},[_c('div',{staticClass:"register-card"},[_c('p',{staticClass:"sub-title",domProps:{"innerHTML":_vm._s(_vm.boxTitle)}}),_vm._v(" "),_c('p-register-card-form')],1),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }